// @flow

import Manual from "./manual.js";
import Keyboard from "./keyboard.js";
import Wheel from "./wheel.js";
import Touch from "./touch.js";

import ScrollHandler from "./handler.js";
export {ScrollHandler};

type HandlersT = Array<ScrollHandler>;

class Void extends ScrollHandler {}

export const Handlers = {
	mount(handlers: HandlersT) {
		for (let i = 0; i < handlers.length; i++) {
			const handler = handlers[i];
			if (handler.mount) { handler.mount(); }
		}
	},
	unmount(handlers: HandlersT) {
		for (let i = 0; i < handlers.length; i++) {
			const handler = handlers[i];
			if (handler.unmount) { handler.unmount(); }
		}
	},
};

// The default handler is `Manual`
export const SCROLL_HANDLERS = [Manual, Keyboard, Wheel, Touch];
export const SCROLL_HANDLERS_NATIVE = [Void, Keyboard];



// WEBPACK FOOTER //
// ./lib/scroller/handlers.js